import formatNumber from '@/utils/NumberFormatter';

interface IUnitInfo {
  unitID: string;
  externalID: string;
  name: string;
  screenWidth: number;
  screenHeight: number;
  latitude: number;
  longitude: number;
  networkName: string;
  siteID: string;
  siteExternalID: string;
  siteName: string;
  city: string;
  region: string;
  mediaTypeName: string;
  mediaOwnerName: string;
  marketNames: string[];
  unitIABBlock: string[];
  spotLength: number;
  minSpotLength: number;
  maxSpotLength: number;
  allowedLanguages: string[];
  allowHTML: boolean;
  allowImage: boolean;
  allowVideo: boolean;
  allowZip: boolean;
  allowAudio: boolean;
}
export interface IUnitInfoAPI {
  unit_id: string;
  unit_external_id: string;
  unit_name: string;
  screen_width: number;
  screen_height: number;
  latitude: number;
  longitude: number;
  network_name: string;
  site_id: string;
  site_external_id: string;
  site_name: string;
  city: string;
  region: string;
  mediatype_name: string;
  mediatype_full_name: string;
  mediaowner_name: string;
  market_names: string[];
  unit_iab_blacklist: string[];
  spot_length: number;
  min_spot_length: number;
  max_spot_length: number;
  allowed_languages: string[];
  allow_html: boolean;
  allow_image: boolean;
  allow_video: boolean;
  allow_zip: boolean;
  allow_audio: boolean;
}

export default class UnitInfo {
  unitID: string;

  externalID: string;

  name: string;

  screenWidth: number;

  screenHeight: number;

  latitude: number;

  longitude: number;

  networkName: string;

  siteID: string;

  siteExternalID: string;

  siteName: string;

  city: string;

  region: string;

  mediaTypeName: string;

  mediaTypeFullName: string;

  mediaOwnerName: string;

  marketNames: string[];

  unitIABBlock: string[];

  spotLength: number;

  minSpotLength: number;

  maxSpotLength: number;

  allowedLanguages: string[];

  allowHTML: boolean;

  allowImage: boolean;

  allowVideo: boolean;

  allowZip: boolean;

  allowAudio: boolean;

  constructor(
    unitID: string,
    externalID: string,
    name: string,
    screenWidth: number,
    screenHeight: number,
    latitude: number,
    longitude: number,
    networkName: string,
    siteID: string,
    siteExternalID: string,
    siteName: string,
    city: string,
    region: string,
    mediaTypeName: string,
    mediaTypeFullName: string,
    mediaOwnerName: string,
    marketNames: string[],
    unitIABBlock: string[],
    spotLength: number,
    minSpotLength: number,
    maxSpotLength: number,
    allowedLanguages: string[],
    allowHTML: boolean,
    allowImage: boolean,
    allowVideo: boolean,
    allowZip: boolean,
    allowAudio: boolean,
  ) {
    this.unitID = unitID;
    this.externalID = externalID;
    this.name = name;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.latitude = latitude;
    this.longitude = longitude;
    this.networkName = networkName;
    this.siteID = siteID;
    this.siteExternalID = siteExternalID;
    this.siteName = siteName;
    this.city = city;
    this.region = region;
    this.mediaTypeName = mediaTypeName;
    this.mediaTypeFullName = mediaTypeFullName;
    this.mediaOwnerName = mediaOwnerName;
    this.marketNames = marketNames;
    this.unitIABBlock = unitIABBlock;
    this.spotLength = spotLength;
    this.minSpotLength = minSpotLength;
    this.maxSpotLength = maxSpotLength;
    this.allowedLanguages = allowedLanguages;
    this.allowHTML = allowHTML;
    this.allowImage = allowImage;
    this.allowVideo = allowVideo;
    this.allowZip = allowZip;
    this.allowAudio = allowAudio;
  }

  get screenSize() {
    return `${formatNumber(this.screenWidth, '0,0')} x ${formatNumber(this.screenHeight, '0,0')}`;
  }

  static fromApi(apiObject: IUnitInfoAPI): UnitInfo {
    return new UnitInfo(
      apiObject.unit_id,
      apiObject.unit_external_id,
      apiObject.unit_name,
      apiObject.screen_width,
      apiObject.screen_height,
      apiObject.latitude,
      apiObject.longitude,
      apiObject.network_name,
      apiObject.site_id,
      apiObject.site_external_id,
      apiObject.site_name,
      apiObject.city,
      apiObject.region,
      apiObject.mediatype_name,
      apiObject.mediatype_full_name,
      apiObject.mediaowner_name,
      apiObject.market_names,
      apiObject.unit_iab_blacklist,
      apiObject.spot_length,
      apiObject.min_spot_length,
      apiObject.max_spot_length,
      apiObject.allowed_languages,
      apiObject.allow_html,
      apiObject.allow_image === true,
      apiObject.allow_video === true,
      apiObject.allow_zip === true,
      apiObject.allow_audio === true,
    );
  }

  get dataRow(): (number | string | boolean | string[])[] {
    return [
      this.externalID,
      this.name,
      this.screenWidth,
      this.screenHeight,
      this.latitude,
      this.longitude,
      this.networkName,
      this.siteExternalID,
      this.siteName,
      this.city,
      this.region,
      this.mediaTypeName,
      this.mediaOwnerName,
      this.marketNames,
      this.unitIABBlock,
      this.spotLength,
      this.minSpotLength,
      this.maxSpotLength,
      this.allowedLanguages,
      this.allowHTML,
      this.allowImage,
      this.allowVideo,
      this.allowZip,
      this.allowAudio,
    ];
  }
}
